import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IConfiguration } from "src/models/General/Configuration.models";

interface configurationstate {
  configurations: IConfiguration[];
  configurationToEdit: IConfiguration | null;
}

const initialState: configurationstate = {
  configurations: [],
  configurationToEdit: null,
};

const configurationSlice = createSlice({
  name: "Configuration",
  initialState,
  reducers: {
    setConfigurationList: (state, action: PayloadAction<IConfiguration[]>) => {
      state.configurations = action.payload;
    },
    concatListConfiguration: (
      state: configurationstate,
      action: PayloadAction<IConfiguration[]>
    ) => {
      state.configurations = [...state.configurations.concat(action.payload)];
    },
    setConfigurationToEdit: (state, action: PayloadAction<IConfiguration | null>) => {
      state.configurationToEdit = action.payload;
    },
    addConfiguration: (state, action: PayloadAction<IConfiguration>) => {
      state.configurations.push(action.payload);
    },
    updateConfiguration: (state, action: PayloadAction<IConfiguration>) => {
      let itemIndex = state.configurations.findIndex(
        item => item.configurationId === action.payload.configurationId
      );
      if (itemIndex !== -1) state.configurations[itemIndex] = action.payload;
    },
    deleteConfiguration: (state, action: PayloadAction<number>) => {
      const newArray = state.configurations.filter(
        item => item.configurationId !== action.payload
      );
      state.configurations = newArray;
    },
  },
});

export const {
  setConfigurationList,
  concatListConfiguration,
  setConfigurationToEdit,
  addConfiguration,
  updateConfiguration,
  deleteConfiguration,
} = configurationSlice.actions;

export default configurationSlice.reducer;
